import React, { ReactElement } from "react";
import enumStrings from "../../../enumStrings";
import ErrorBasePage from "./ErrorBasePage";

const Error500 = (): ReactElement => {
  return (
    <ErrorBasePage
      title={enumStrings.pages.error500.title}
      subtitle={enumStrings.pages.error500.subtitle}
      description={enumStrings.pages.error500.description}
      emailSubject={enumStrings.pages.error500.emailSubject}
    />
  );
};

export default Error500;
